
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/[industryPages]",
      function () {
        return require("private-next-pages/industries/[industryPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/[industryPages]"])
      });
    }
  